import { useState } from 'react';
import { ListItemText, ListItem } from '@mui/material';
import BaseFieldEditor from './BaseFieldEditor';
import EquipmentIdSelector from '../selectors/EquipmentIdSelector';

// eslint-disable-next-line
const EquipmentIdEditor = ({
  buildingId,
  open,
  column,
  editing,
  currentlyEditing,
  setCurrentlyEditing,
  setCurrentEditor,
  actions,
}) => {
  if (!editing || editing.length <= 0) return null;
  const [selectedOption, setSelectedOption] = useState(editing[0].equip_id);

  return (
    <BaseFieldEditor
      open={open}
      onSave={() => {
        const action = actions.find((a) => a.id === column.action);
        action.doSave(editing, {
          'p.equip_id': selectedOption,
        });
        action.doClose({ currentlyEditing, setCurrentlyEditing, column, setCurrentEditor });
      }}
      title="Equipment Id Editor"
      editing={editing}
      column={column}
      currentlyEditing={currentlyEditing}
      setCurrentlyEditing={setCurrentlyEditing}
      setCurrentEditor={setCurrentEditor}
      actions={actions}
    >
      <EquipmentIdSelector
        buildingId={buildingId}
        value={selectedOption}
        setValue={setSelectedOption}
        sortOptions={String.compare}
        renderOption={(props, option) => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <ListItem {...props}>
            <ListItemText>{option}</ListItemText>
          </ListItem>
        )}
      />
    </BaseFieldEditor>
  );
};

export default EquipmentIdEditor;
